import { useParams, useNavigate } from 'react-router';
import { ChevronLeft } from 'lucide-react';
import { useWorkspace } from '@/contexts/workspace-context';
import { DeliveriesPanel } from '@/components/deliveries/deliveries-panel';
import { Button } from '@/components/ui/button';
import { channelDisplayName } from '@/lib/channel-display';
import { PageContainer } from '@/components/page-container';
import { workspaceUrl } from '@/lib/workspace-url';

export function ChannelLogsPage() {
  const { ws, channelId } = useParams<{ ws: string; channelId: string }>();
  const { channels } = useWorkspace();
  const navigate = useNavigate();

  if (!channelId) {
    return <div className="p-8 text-sm text-muted-foreground">Missing channel id.</div>;
  }

  const channel = channels.find((c) => c.id === channelId);

  return (
    <PageContainer variant="fill" className="gap-4">
      <Button
        variant="outline"
        size="icon"
        className="self-start"
        onClick={() =>
          navigate(ws ? workspaceUrl(ws, `channels/${channelId}`) : -1)
        }
        aria-label="Back to channel"
      >
        <ChevronLeft className="h-5 w-5" />
      </Button>
      <h1 className="text-2xl font-semibold tracking-tight">
        Channel Logs
        {channel ? `: ${channelDisplayName(channel)}` : ''}
      </h1>
      <DeliveriesPanel scope={`channel:${channel?.id ?? channelId}`} channelType={channel?.type} />
    </PageContainer>
  );
}
